module.exports = __webpack_public_path__ + "static/media/trusted-flip.c484e9b6.png";